import { render, staticRenderFns } from "./AddResourcest.vue?vue&type=template&id=388b736a&"
import script from "./AddResourcest.vue?vue&type=script&lang=js&"
export * from "./AddResourcest.vue?vue&type=script&lang=js&"
import style0 from "./AddResourcest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports